import { connect } from "knockout-store";
import { getGlossaryData } from "../../utils/content";

function glossaryViewmodel(params) {
  const vm = {};
  // vm.isVisible = () => params.popUp() === "glossary";
  vm.currentId = () => {
    return params.glossaryID();
  };
  vm.image = () => {
    console.log(
      getGlossaryData(params.glossaryData(), params.glossaryID(), "image")
    );

    return getGlossaryData(params.glossaryData(), params.glossaryID(), "image");
  };
  vm.content = () => {
    return getGlossaryData(
      params.glossaryData(),
      params.glossaryID(),
      "content"
    );
  };
  vm.title = () => {
    return getGlossaryData(params.glossaryData(), params.glossaryID(), "title");
  };
  return vm;
}

function mapStateToParams({ popUp, route, glossaryID, glossaryData }) {
  return { popUp, route, glossaryID, glossaryData };
}

export default connect(mapStateToParams)(glossaryViewmodel);
